import { render, staticRenderFns } from "./WithBranch.vue?vue&type=template&id=380a289e&scoped=true&"
import script from "./WithBranch.vue?vue&type=script&lang=js&"
export * from "./WithBranch.vue?vue&type=script&lang=js&"
import style0 from "./WithBranch.vue?vue&type=style&index=0&id=380a289e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a289e",
  null
  
)

export default component.exports